import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Spinner,
  Text,
  useToast,
  VStack,
} from '@chakra-ui/react'
import Cookies from 'js-cookie'
import React, { useState } from 'react'
import { FiEye, FiEyeOff } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import VersionInfo from '../components/VersionInfo'
import api from '../utils/api'

function LoginPage() {
  const navigate = useNavigate()
  const toast = useToast()

  // Estados de login
  const [user, setUser] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [errors, setErrors] = useState({ user: '', password: '' })

  // Estados para publicação
  const [publication, setPublication] = useState('')
  const [configExists, setConfigExists] = useState<boolean | null>(true)
  const [pubError, setPubError] = useState('')

  // Validação do formulário de login
  const validateLoginForm = () => {
    const newErrors = { user: '', password: '' }
    if (!user) newErrors.user = 'O e-mail é obrigatório'
    if (!password) newErrors.password = 'A senha é obrigatória'
    setErrors(newErrors)
    return !newErrors.user && !newErrors.password
  }

  // Função para checar se o config existe no back
  const checkConfigExists = async (pubCode: string) => {
    try {
      const response = await api.get('/auth/config-exists', {
        params: { publication: pubCode },
      })
      setConfigExists(response.data.exists)
    } catch (error) {
      console.error('Erro ao verificar config:', error)
      setConfigExists(false)
    }
  }

  // Gera o config (quando não há publicação configurada)
  // Alteração no handleGenerateConfig para validar o campo antes de prosseguir:
  const handleGenerateConfig = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!publication) {
      setPubError("O código da publicação é obrigatório.");
      return;
    }
    setIsLoading(true);
    setPubError('');
    try {
      const response = await api.post('/auth/generate-config', { publication });
      if (response.status === 200) {
        localStorage.setItem('publication', publication);
        await checkConfigExists(publication);
      } else {
        setPubError('Erro ao gerar configuração. Tente novamente.');
      }
    } catch (error) {
      console.error('Erro ao gerar configuração:', error);
      setPubError('Erro ao gerar configuração. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Entrada do totem.
   *
   * Antes nao validava nada: qualquer usuario e qualquer senha entravam, inclusive campos
   * vazios. A funcao que consultaria o backend (handleLogin, abaixo) e codigo morto —
   * nenhum botao a usa, e a rota /auth/validate-user que ela chama nao existe no servidor.
   *
   * Agora usa a mesma credencial dos demais modulos. Continua chumbada no bundle publico;
   * o conserto de verdade e o AuthModule, previsto para depois do evento.
   */
  const handleLogin2 = async (e: React.FormEvent) => {
    if (user.trim().toLowerCase() !== 'sabri' || password !== 'SabriEventos0610') {
      toast({
        title: 'Usuário ou senha inválidos',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
      return
    }

    toast({
      render: () => (
        <Box
          color="white"
          p={6}
          bg="green.500"
          fontSize="4xl"
          borderRadius="md"
          textAlign="center"
          borderWidth="2px"
          borderColor="white"
        >
          Login bem-sucedido!
        </Box>
      ),
      duration: 3000,
      isClosable: true,              
      status: 'success',
    })

    // Armazenar no localStorage
    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('user', user);
    localStorage.setItem('publication', String('publication'));
    localStorage.setItem('content', String('content'));
    localStorage.setItem('configuration', String('configuration'));
    localStorage.setItem('formatPublication', String('formatPublication'));

    // Navegar para tela principal
    navigate('/autoatendimento', { state: { publication } });
  }

  // Handle de login (executado se a publicação já estiver configurada)
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!validateLoginForm()) return
    localStorage.removeItem('isAuthenticated');
    const publication = localStorage.getItem('publication');
    if (!publication) {
      toast({
        title: 'Erro no login',
        description: 'Código da publicação não encontrado!',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
      setConfigExists(false);
      return
    }
    setIsLoading(true)
    try {
      const response = await api.post('/auth/validate-user', {
        login: user,
        password,
        publication,
      })
      Cookies.set('token', response.data.token, { expires: 1 })     
      if (response.status === 200) {
        toast({
          title: 'Login bem-sucedido!',
          description: 'Você será redirecionado ao dashboard.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        })
        const { content, configuration, formatPublication } = response.data;
        // Armazenar no localStorage
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('user', user);
        localStorage.setItem('publication', String(publication));
        localStorage.setItem('content', String(content));
        localStorage.setItem('configuration', String(configuration));
        localStorage.setItem('formatPublication', String(formatPublication));

        // Chamar a rota /sync-files para sincronizar os arquivos
        const syncPromise = api.get(
          `/sync-files?contentId=${content}&publicationId=${publication}`
        );

        // Garantir que a tela de carregamento dure pelo menos 3 segundos
        const delay = new Promise((resolve) => setTimeout(resolve, 3000));

        await Promise.all([syncPromise, delay]);

        // Navegar para tela principal
        navigate('/cadastro', { state: { publication } });
      } else {
        toast({
          title: 'Erro no login',
          description: 'Login invalido!',
          status: 'error',
          duration: 3000,
          isClosable: true,
        })
      }
    } catch (error: any) {
      toast({
        title: 'Erro no login',
        description: error.response?.data?.message || 'Ocorreu um erro inesperado.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
      if (error.response && error.response.status === 401) {
        toast({
          title: 'Erro no login',
          description: 'Usuário ou senha inválidos!',
          status: 'error',
          duration: 3000,
          isClosable: true,
        })
      } else if (error.response && error.response.status === 404) {
        window.location.reload();
      } else {
        toast({
          title: 'Erro no login',
          description: 'Erro ao autenticar. Tente novamente.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        })
      }
    } finally {
      setIsLoading(false)
    }
  }

  // Renderização enquanto verifica config
  if (configExists === null) {
    return (
      <Box minH="100vh" display="flex" alignItems="center" justifyContent="center">
        <Spinner size="xl" />
      </Box>
    )
  }

  return (
    <Box
      minH="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Box w="full" maxW={{ base: 'sm', md: 'md', lg: 'lg' }} textAlign="center" p={4}>
        <Heading as="h1" size="2xl" mb={8}>
          Bem-vindo!
        </Heading>        
        {configExists ? (
          // Formulário de Login
          <VStack spacing={6} align="stretch">
            <FormControl isInvalid={!!errors.user}>
              <FormLabel>Usuário</FormLabel>
              <Input
                type="text"
                placeholder="Digite seu usuário"
                size="lg"
                value={user}
                onChange={(e) => setUser(e.target.value)}
              />
              {errors.user && <FormErrorMessage>{errors.user}</FormErrorMessage>}
            </FormControl>
            <FormControl isInvalid={!!errors.password}>
              <FormLabel>Senha</FormLabel>
              <InputGroup size="lg">
                <Input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Digite sua senha"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <InputRightElement width="3rem">
                  <Button
                    variant="ghost"
                    colorScheme='none'
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </Button>
                </InputRightElement>
              </InputGroup>
              {errors.password && <FormErrorMessage>{errors.password}</FormErrorMessage>}
            </FormControl>
            <Button variant="solid" colorScheme='blue' size="lg" width="full" onClick={handleLogin2} isLoading={isLoading}>
              Entrar
            </Button>
            <Heading size="0xl" mb={8}>
              <VersionInfo />
            </Heading>
          </VStack>
        ) : (
          // Formulário de geração de Configuração de Publicação
          <VStack spacing={6} align="stretch">
            <FormControl isRequired>
              <FormLabel>Código da Publicação</FormLabel>
              <Input
                type="text"
                placeholder="Informe o código da publicação"
                value={publication}
                onChange={(e) => setPublication(e.target.value.replace(/\D/g, ''))}
                required
              />
            </FormControl>
            {pubError && <Text color="red.500">{pubError}</Text>}
            <Button fontSize={"28px"} width="full" onClick={handleGenerateConfig} isLoading={isLoading}>
              {isLoading ? 'Gerando configuração...' : 'Gerar Configuração'}
            </Button>
          </VStack>
        )}
      </Box>
    </Box>
  )
}

export default LoginPage
// Compare this snippet from src/pages/Autoatendimento.tsx: